
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CPOpenAccountFormSubsection extends Vue {
  @Prop({ required: false })
  public readonly title?: string;

  @Prop({ default: false })
  public readonly showShadow?: boolean;

  @Prop({ default: false })
  public readonly noBorder?: boolean;

  @Prop({ required: false })
  public readonly caption?: string;
}
